namespace appn.views.dataSource.map {

    class InitArgs {
        userLatLon: string = appn.emptyString;
        headers: Array<Header> = [];
        referringHeaders: { [key: string]: Array<string>; } = {};
        dataSourcesMapEntries: string = emptyString;
        canUseFilterOptions: boolean = false;
    }

    // Set filters variables so that they are not undefined when displaying a map without filters.
    const _searchString: string = appn.emptyString;
    const _filter: string = appn.emptyString;
    const _headerTypes: { [key: string]: string } = {};
    const _referringDatasourceColumns: { [key: string]: ReferringDatasourceColumn } = {};

    let _filterOptions: any = [];
    let _filterIdsInUse: number[] = [];
    let _initArgs: InitArgs;
    let _displayedColumn = 'all';
    let _formula: string;
    let _sortType = '0'; // 0 - Asc, 1 - Desc, 2 - None
    let _sortTypeColumn: string;

    let _map: L.Map;
    let _entrieslayers: Array<L.Layer> = [];
    let _pageNum = 1;
    let _totalEntries = 0;
    let _resultsWithoutGPS = 0;
    let _resultsWithGPS = 0;

    let _filterCount = 1;
    let _filterOptionTemplate: JQuery<HTMLElement>;

    export function init(args: InitArgs): void {
        _initArgs = args;

        // Stop flashing of these controls
        $('#GoPrevious').hide();
        $('#GoNext').hide();
        $('#noGPSResultsWarning').hide();

        // Resize map div to take up all available height
        _map = appn.ui.mapInit('map', 0, 0, 11, false);

        // Check querystring for inputs, assume all set by server
        if (($ as any).getUrlVar('dataSourceId') !== appn.emptyString)
            getEntries();

        // Filter Controls
        _filterIdsInUse.push(1);
        _filterOptionTemplate = $('#filterOptionsBox1').clone();

        if (_initArgs.headers) {
            const headersArray = _initArgs.headers;

            for (let i = 0; i < headersArray.length; i++) {
                const header = headersArray[i];
                // Set the header types
                _headerTypes[header.name] = header.dataType;

                // Set columns which refer to another datasource
                if (header.refId && _initArgs.referringHeaders.keys?.length > 0 && _initArgs.referringHeaders[header.name].length > 0) {
                    // Get the list of columns for the datasource
                    const columns: string[] = _initArgs.referringHeaders[header.name];

                    // Make string safe
                    for (let i = 0; i < columns.length; i++)
                        columns[i] = columns[i].replace(`'`, appn.emptyString).replace(`"`, appn.emptyString);

                    // Create an object to hold the data for each column
                    const referringDatasourceColumn: ReferringDatasourceColumn = { refId: header.refId, columns: columns };

                    // Add all the columns into one object
                    _referringDatasourceColumns[header.name] = referringDatasourceColumn;

                    // Set the header type of this header to "DataSource" so that it can be identified. "$(document).on('change', '.filterHeader', function (e) {"
                    _headerTypes[header.name] = 'DataSource';
                }
            }
        }

        addEvents();
        addDateTimePickerOnInit();
    }

    appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function(channel: string, data: any) {
        if (!_map)
            return;

        _map.invalidateSize();
    });

    function addEvents() {
        $('#applyOptions').click(function(e) {
            e.preventDefault();

            _pageNum = 1;
            getEntries();
        });

        $('#PageSize').change(function() {
            _pageNum = 1;
            getEntries();
        });

        $('#GoPrevious').click(function() {
            _pageNum--;
            getEntries();
        });

        $('#GoNext').click(function() {
            _pageNum++;
            getEntries();
        });

        $('#addFilter').on('click', function() {
            addFilter(true);
        });

        // Slightly different syntax for .click as the elements are created dynamically.
        $(document.body).on('click', '.deleteFilterOption', function(e) {

            const filterToDelete = ($(this).attr('id') as string).replace('deleteFilterOption', '');

            // Don't allow the last filter to be removed, instead reset its values.
            if (_filterCount <= 1) {
                $('#filterHeader' + filterToDelete).prop('selectedIndex', 0).change();
                $('#filterFunction' + filterToDelete).prop('selectedIndex', 0).change();
                $('#filterBy' + filterToDelete).val('');
                addDateTimePickerOnInit(filterToDelete);
                select.init({ selector: '#filterOptions select[id^=filter]' });
            } else {

                $('#filterOptionBox' + filterToDelete).remove();

                // Remove the ID from filterIdsInUse
                const index = _filterIdsInUse.indexOf(parseInt(filterToDelete, undefined));
                _filterIdsInUse.splice(index, 1);

                // Only reduce the real count as this could result in duplicate ID's when a new filter is added after one is removed.
                _filterCount--;

                for (let i = 0; i < _filterCount; i++) {
                    let newTemplate = $('#container-filterOptionTemplate').html();
                    newTemplate = newTemplate.replace(/_id_/g, i + 1 as unknown as string);
                    $('#filterOptionBox' + _filterIdsInUse[i]).replaceWith(newTemplate);
                }
                _filterIdsInUse = Array.from({ length: _filterCount }, (_, i) => i + 1);
                select.init({ selector: '#filterOptions select[id^=filter]' });
            }
        });

        $('#applyFilters').click(function(e) {
            const dataSourceId = $('#DataSourceId').val();
            _filterOptions = [];

            // Get all the filters
            for (let i = 0; i < _filterIdsInUse.length; i++) {
                const filterOption: any = new Object();
                filterOption.header = $('#filterHeader' + _filterIdsInUse[i]).val();
                filterOption.function = $('#filterFunction' + _filterIdsInUse[i]).val();
                filterOption.by = $('#filterBy' + _filterIdsInUse[i]).val();

                _filterOptions.push(filterOption);
            }

            // Post the result
            getEntries();

            // Close the modal
            $('#filterOptionsModal').modal('toggle');
        });

        $('.btnFilterOptions').click(function(event) {
            if (_initArgs.canUseFilterOptions)
                $('#filterOptionsModal').modal('show');
            else
                $('#showModalOnClick').modal('show');
        });

        $('#filterOptionsModal').on('shown.bs.modal', function() {
            select.init({ selector: '#filterOptions select[id^=filter]' });
        });

        // Clear the filters
        $(document).on('click', '#clearFilters', function(e) {
            // Posting an empty array back will clear the filters.
            _filterOptions = [];

            // Post the result
            getEntries();
        });

        // Change the input type for filtering for special columns types
        $(document).on('change', '.filterHeader', function(e) {

            const id = ($(this).attr('id') as string).replace('filterHeader', '');
            const header = String($(this).find(':selected').val());
            const headerType = _headerTypes[header];

            switch (headerType) {
                case 'DateTime':
                    // If the current item is a date picker
                    if (!$('#filterBy' + id).parent().hasClass('datetimepicker'))
                        $('#filterBy' + id).each(function () {
                            $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                                .insertBefore(this);
                        }).remove();

                    // Add the function to display the popup calendar.
                    // The calendar only displays on the second click,
                    // so simulate one click to make it instant for users.
                    $('#filterBy' + id).on('click', function() {
                        appn.ui.dateTimePicker(($(this) as any), undefined, 'YYYY-MM-DD HH:mm:ss');
                    }).trigger('click');
                    break;
                case 'DataSource':
                    // If the current item is a date picker
                    if ($('#filterBy' + id).parent().hasClass('datetimepicker')) {
                        $('#filterBy' + id).parent().each(function() {
                            $('<select class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '"></select>')
                                .insertBefore(this);
                        }).remove();

                        // Add all the options for this column
                        const columns = _referringDatasourceColumns[header].columns;
                        for (let i = 0; i < columns.length; i++) 
                            $('#filterBy' + id).append($('<option>', {
                                value: columns[i],
                                text: columns[i]
                            }));
                    } else {
                        $('#filterBy' + id).each(function() {
                            $('<select class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '"></select>')
                                .insertBefore(this);
                        }).remove();

                        // Add all the options for this column
                        const columns = _referringDatasourceColumns[header].columns;
                        for (let i = 0; i < columns.length; i++) 
                            $('#filterBy' + id).append($('<option>', {
                                value: columns[i],
                                text: columns[i]
                            }));
                    }
                    break;
                default:
                    // If the current item is a date picker
                    if ($('#filterBy' + id).parent().hasClass('datetimepicker'))
                        $('#filterBy' + id).parent().each(function() {
                            $('<input class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '" type="text">')
                                .insertBefore(this);
                        }).remove();
                     else 
                        $('#filterBy' + id).each(function() {
                            $('<input class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '" type="text">')
                                .insertBefore(this);
                        }).remove();
                    break;
            }
        });
    }

    function getEntries() {
        const dataSourceId = $('#DataSourceId').val();
        const pageSize = $('#PageSize').val();

        _displayedColumn = $('#DisplayedColumnList').find(':selected').val() as string;
        _formula = $('#Formula').val() as string;
        _sortType = $('#SortTypeList').find(':selected').val() as string;
        _sortTypeColumn = $('#SortTypeColumnList').find(':selected').val() as string;

        const $form = $('form#appnForm');
        if ($form.valid())
            appn.ajax.post({
                url: _initArgs.dataSourcesMapEntries,
                data: {
                    dataSourceId: dataSourceId, displayedColumn: _displayedColumn,
                    filter: _filter, formula: _formula, searchString: _searchString,
                    sortType: _sortType, sortTypeColumn: _sortTypeColumn,
                    pageSize: pageSize, pageNum: _pageNum, filterOptions: JSON.stringify(_filterOptions)
                },
                done: processResult
            });
    }

    function addFilter(incrementFilterCount?: boolean) {
        if (incrementFilterCount)
            _filterCount++;

        _filterIdsInUse.push(_filterCount);

        // Destroy the old select2 elements to clone a fresh template
        select.destroy('#filterOptions select[id^=filter]');

        // Rename ID's and then append the template
        // NOTE: Chain .attr when changing the ID, as the original doesn't exist after the ID is changed.
        let newTemplate = $('#container-filterOptionTemplate').html();
        newTemplate = newTemplate.replace(/_id_/g, _filterCount as unknown as string).replace('select2-noinit', emptyString);
        $('#filterOptions').append(newTemplate);
        addDateTimePickerOnInit(_filterCount.toString());

        select.init({ selector: '#filterOptions select[id^=filter]' });
    }

    function processResult(data: any) {
        // remove the existing markers ready for the new set being drawn
        removeMarkers();

        const bounds: [number, number][] = [];
        const userLatLon = _initArgs.userLatLon.split(',');
        const userLat: number = userLatLon[0] as any;
        const userLon: number = userLatLon[1] as any;
        let firstEntryLatLng = new L.LatLng(userLat, userLon); // Default to user country
        let firstPopup;

        // results without GPS co-ordinates are not pass through in data.Entries, but are include in the iTotalRecords.
        _resultsWithoutGPS = data.iTotalRecordsWithoutGPS;
        _resultsWithGPS = data.iTotalRecords - data.iTotalRecordsWithoutGPS;
        const allEntriesll: L.LatLng[] = [];
        // process the received entries onto the map
        for (let i = 0; i < data.Entries.length; i++) {
            const lat = data.Entries[i][0];
            const lon = data.Entries[i][1];
            const title = data.Entries[i][2];
            const subTitle = data.Entries[i][3];
            const imageSrc = data.Entries[i][4];
            const pinColour = data.Entries[i][5];
            const pinOutline = (pinColour === 'null') ? 'null' : shadeBlendConvert(0.3, pinColour);

            if (lat !== 0 && lon !== 0) { // Exclude 0,0 lat/lon since this is a fail to capture GPS on device
                const entriesll = new L.LatLng(lat, lon);
                allEntriesll.push(entriesll);
                bounds.push([entriesll.lat, entriesll.lng]);

                let icon = L.divIcon({ // Some styles need to be defined inline as they depend on conditional styling of the column
                    html: '<div class="appn-mapPin"></div>' +
                        '<div class="appn-mapShadow"></div>'
                });

                if (pinColour !== 'null')
                    icon = L.divIcon({ // Some styles need to be defined inline as they depend on conditional styling of the column
                        html: '<div class="appn-mapPin" style="background: ' + pinColour + '; ' +
                            'border: 2px solid ' + pinOutline + ';' +
                            '"></div>' +

                            '<div class="appn-mapShadow" style="background: ' + pinColour + '; ' +
                            '"></div>'
                    });

                const entriesmark = new L.Marker(entriesll, { icon: icon });
                entriesmark.on('click', markerClick);

                // Add the row contents
                (entriesmark as any).data = data.Entries[i];
                (entriesmark as any).data.splice(0, 5); // Remove lat, lon, title, subTitle, imageSrc and pinColour values

                _map.addLayer(entriesmark);
                _entrieslayers.push(entriesmark);

                let popupText;
                let popup;
                if (title !== appn.emptyString || subTitle !== appn.emptyString || imageSrc !== appn.emptyString) {

                    popupText = '<div class="appnMapPopup">';

                    if (title !== appn.emptyString)
                        popupText += '<h5> ' + title + '</h5>';
                    if (subTitle !== appn.emptyString)
                        popupText += subTitle + '<br />';
                    if (imageSrc !== appn.emptyString)
                        popupText += '<img src=' + imageSrc + ' style="display: block; margin: auto; width: 200px;"  />';

                    popupText += `<span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${lat} ${lon}</span>`;

                    popupText += '</div>';
                    popup = entriesmark.bindPopup(popupText);
                }

                if (i === 0) {
                    firstPopup = popup;
                    firstEntryLatLng = entriesll;
                }

            }
        }

        updateUI(data);

        if (bounds.length > 0) {
            _map.fitBounds(bounds as L.LatLngBoundsExpression);
            $('#noGPSResultsWarning').hide();
        } else {
            _map.setView(firstEntryLatLng, 6);
            $('#noGPSResultsWarning').show();
        }

        const filtersContainer = $('.map-filters');
        filtersContainer.html(emptyString);
        appn.sideFilterAndContent.appendShowButton(filtersContainer);

        // add columns as label/spans to panel
        const cols = data.ColumnHeaders;

        // Remove disabled attribute if it is on the child
        const entryDiv = $('#entryData');
        entryDiv.empty();

        for (let i = 0; i < cols.length; i++)
            entryDiv.append('<tr><td><label class="mb-0">' + cols[i] + '</label></td><td class="displayText"></td></tr>');
    }

    function updateUI(data: any) {
        const pageSize = $('#PageSize').val() as number;
        _totalEntries = data.iTotalRecords;

        let totalText = appn.emptyString;
        if (_totalEntries > 0) {
            if (_resultsWithGPS > 0)
                totalText = T('Found {0} to {1} of {2} rows', (pageSize * _pageNum) - pageSize + 1,
                    Math.min(pageSize * _pageNum, _resultsWithGPS), _resultsWithGPS) + '<br>';
            if (_resultsWithoutGPS > 0)
                totalText += '<i>(' + T('Cannot show {0} rows due to missing GPS location', _resultsWithoutGPS) + ')</i>';
        } else
            totalText = T('No results found');

        $('#AppliedFilters').html(data.OtherData[0]);

        $('#TotalsText').html(totalText);

        if ((pageSize * _pageNum) < (_totalEntries - _resultsWithoutGPS))
            $('#GoNext').show();
        else
            $('#GoNext').hide();

        if (_pageNum > 1)
            $('#GoPrevious').show();
        else
            $('#GoPrevious').hide();
    }

    function markerClick(event: any) {
        // if a marker is clicked, display the details from it
        const entryDivs = $('.displayText');

        for (let i = 1; i < event.target.data.length; i++)
            $(entryDivs[i - 1]).html(event.target.data[i]);
    }

    function removeMarkers() {
        // remove each 'layer' with a marker in it.
        for (let i = 0; i < _entrieslayers.length; i++)
            _map.removeLayer(_entrieslayers[i]);
        _entrieslayers = [];
    }

    // Source: https://stackoverflow.com/a/13542669
    function shadeBlendConvert(this: any, p: number, from: string, to: string = appn.emptyString) {
        if (typeof (p) !== 'number' || p < -1 || p > 1 || typeof (from) !== 'string' || (from[0] !== 'r' && from[0] !== '#') || (typeof (to) !== 'string' && typeof (to) !== 'undefined')) return null; // ErrorCheck
        if (!this.sbcRip) this.sbcRip = function(d: any) {
            const l = d.length, RGB = new Object() as any;
            if (l > 9) {
                d = d.split(',');
                if (d.length < 3 || d.length > 4) return null;// ErrorCheck
                RGB[0] = i(d[0].slice(4));
                RGB[1] = i(d[1]);
                RGB[2] = i(d[2]);
                RGB[3] = d[3] ? parseFloat(d[3]) : -1;
            } else {
                if (l === 8 || l === 6 || l < 4) return null; // ErrorCheck
                if (l < 6) d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? d[4] + appn.emptyString + d[4] : appn.emptyString); // 3 digit

                d = i(d.slice(1), 16);
                RGB[0] = d >> 16 & 255;
                RGB[1] = d >> 8 & 255;
                RGB[2] = d & 255;
                RGB[3] = l === 9 || l === 5 ? r(((d >> 24 & 255) / 255) * 10000) / 10000 : -1;
            }
            return RGB;
        };
        const i = parseInt;
        const r = Math.round;
        let h = from.length > 9;
        h = typeof (to) === 'string' ? to.length > 9 ? true : to === 'c' ? !h : false : h;
        const b = p < 0;
        p = b ? p * -1 : p;
        to = to && to !== 'c' ? to : b ? '#000000' : '#FFFFFF';
        const f = this.sbcRip(from);
        const t = this.sbcRip(to);
        if (!f || !t) return null; // ErrorCheck
        if (h) return 'rgb(' + r((t[0] - f[0]) * p + f[0]) + ',' + r((t[1] - f[1]) * p + f[1]) + ',' + r((t[2] - f[2]) * p + f[2]) + (f[3] < 0 && t[3] < 0 ? ')' : ',' + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000 : t[3] < 0 ? f[3] : t[3]) + ')');
        return '#' + (0x100000000 + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 255) : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255) * 0x1000000 + r((t[0] - f[0]) * p + f[0]) * 0x10000 + r((t[1] - f[1]) * p + f[1]) * 0x100 + r((t[2] - f[2]) * p + f[2])).toString(16).slice(f[3] > -1 || t[3] > -1 ? 1 : 3);
    }

    // if the first column is datatime, we have to add the date time picker on init
    function addDateTimePickerOnInit(id: string = '1') {
        const $filterHeader = $('#filterHeader' + id);
        const header = $filterHeader.find(':selected').val() as string;
        const headerType: string = _headerTypes[header];
        if (headerType === 'DateTime') {
            if (!$('#filterBy' + id).parent().hasClass('datetimepicker')) {
                const val = $('#filterBy' + id).val();
                $('#filterBy' + id).parent().each(function () {
                    $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="${val}">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                        .insertBefore(this);
                }).remove();
            }

            // Add the function to display the popup calendar.
            // The calendar only displays on the second click,
            // so simulate one click to make it instant for users.
            $('#filterBy' + id).on('click', function() {
                appn.ui.dateTimePicker(($(this) as any), undefined, 'YYYY-MM-DD HH:mm:ss');
            }).trigger('click');
        }
    }

    interface Header {
        name: string;
        refId: string;
        dataType: string;
    }

    interface ReferringDatasourceColumn {
        refId: string;
        columns: Array<string>;
    }
}
